var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderShapeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.303,
    height: 11.451,
    viewBox: "0 0 13.303 11.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M-835.175,8069.992c-1.59-.9-2.985-2-4.278-2a2.459,2.459,0,0,0-1.94,1.047c-4.037-1.874-4.9-4.068-4.9-4.068a2.878,2.878,0,0,0-2.186,2.583c0,1.141.867,2.363,2.791,3.145-1.934.783-2.791,2-2.791,3.131a2.878,2.878,0,0,0,2.186,2.592s.862-2.193,4.9-4.068a2.462,2.462,0,0,0,1.935,1.057c1.272,0,2.652-1.082,4.283-2",
    transform: "translate(848.478 -8064.972)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderShapeLeft);
export default __webpack_public_path__ + "static/media/header-shape-left.ce6e7723ba9136355da402b3d066be6f.svg";
export { ForwardRef as ReactComponent };